import { Directive, Input, HostListener } from '@angular/core';
import { WebHelperService } from '@libs/libraries/frontend';
import { Util } from '@libs/utilities/util';


/**------------------------------------------------------
 * Open Link
 * ---------
 * Opens a link in a new tab
 *
 * Example:
 * --------
 * 	<button [ngLink]="https://www.w3schools.com/" newWindow> ... </button>
 */
@Directive({
    selector: '[ngLink]',
    standalone: false
})
export class NgLinkDirective {

	@Input() ngLink		: string = '';
	@Input() newWindow !: any;

	constructor(
		private webHelperService: WebHelperService
	) {}

	@HostListener('click')
	onClick(): void {

		//0 - check for data
		if (Util.String.isEmpty(this.ngLink)) throw new Error(`Directive => NgLinkDirective => FATAL ERROR: link was not provided`);

		//1 - check to open in a new tab
		if (!Util.Basic.isUndefined(this.newWindow)) this.webHelperService.openNewTab(this.ngLink);
			else this.webHelperService.openNewTab(this.ngLink);
	}
}
